<template>
    <div>
        <a title="View" class="btn btn-sm akkurate-warning custom-pointer text-white" v-b-modal="String(data.id)">
            <span class="akkurate-small"> <font-awesome-icon :icon="['fas', 'eye']" /></span>
        </a>
        <b-modal :id="String(data.id)" ref="modal" size="xl" @show="ModalOpened">
            <template #modal-title>
                <h6 class="m-0 fw-bold text-green">Audit View</h6>
            </template>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <beat-loader-component v-if="isLoading" :isLoading="isLoading"></beat-loader-component>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="log_name">Log Name</label>
                        <b-form-group id="log_name" label-for="log_name">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="getLogName" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="event">Event</label>
                        <b-form-group id="event" label-for="event">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="getEvent" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="updated_at">Date And Time</label>
                        <b-form-group id="updated_at" label-for="updated_at">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" :value="formatDateAndTime(data.updated_at)" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark" for="updated_at">User</label>
                        <b-form-group id="updated_at" label-for="updated_at">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="text" v-model="getUser" disabled></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-12">
                        <label class="akkurate-dark" for="description">Description</label>
                        <b-form-group id="description" label-for="description">
                            <b-form-textarea class="mb-3 mt-2 field-container fields" v-model="getDescription" disabled></b-form-textarea>
                        </b-form-group>
                    </div>

                </div>
                <!-- <div class="card">
                    <div class="card-header">
                        <h6 class="m-0 fw-bold text-green">Journal Transactions</h6>
                    </div>
                    <div class="card-body table_text_size">
                        <b-table :fields="fields" striped hover :items="items" bordered>
                        </b-table>
                    </div>

                </div> -->
            </div>

            <template #modal-footer="{ ok }">
                <div class="w-100">
                    <!-- begin loader -->
                    <!-- <beat-loader-component 
               class="float-left"
               v-if="isLoading"
               :isLoading="isLoading"
               ></beat-loader-component> -->
                    <!-- end loader -->
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button @click="$bvModal.hide(String(data.id))" type="button" class="akkurate-grey-btn btn-size float-right border-0"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Close</b-button>
                    <!-- <b-button @click="ok()" type="submit" class="akkurate-green-btn btn-size me-2 float-right border-0">Add</b-button>      -->
                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import ApiService from "@/core/services/api.service";
import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";
export default {
    name: "JournalView",
    props: ['data'],
    components: {
        BeatLoaderComponent,
    },
    data() {
        return {
            form: {
                branch: []
            },
            isLoading: false,
            // fields: [
            //     { key: 'id', label: '#' },
            //     { key: 'amount_requested', label: 'Amt Req' },
            //     { key: 'amount_approved', label: 'Amt App' },
            //     { key: 'dr_amount', label: 'Debit Amt' },
            //     { key: 'cr_amount', label: 'Credit Amt' },
            //     { key: 'dr_amount_approved', label: 'Debit Amt App' },
            //     { key: 'cr_amount_approved', label: 'Credit Amt App' },
            //     { key: 'coa_sub_head', label: 'COA Subhead' },
            // ],
            // items: [],
        }
    },
    computed: {
        getBranch() {
            if (this.data.branch) {
                return this.data.branch.name;
            }
            return "";

        },
        getLogName() {
            if (this.data.log_name.toLowerCase() == "account") {
                return this.data.log_name + " - " + this.data.subject?.account_number;
            }
            else {
                return this.data.log_name;
            }
        },
        getEvent() {
            if (this.data.event) {
                return this.data.event;
            }
            return this.data.log_name || "";
        },
        getDescription() {
            let description = this.data.description || "";
            if (this.data.causer?.narration) {
                description += ' (' + this.data.causer?.narration + ')';
            }
            if (this.data.subject?.account_number) {
                description += ' - ' + this.data.subject?.account_number + ' (' + this.data.subject.account_name + ')';
            }
            // if (this.data.subject?.loan_number && this.data.subject?.loan_type) {
            //     description += ' - ' + this.data.subject.loan_number + ' (' + this.data.subject.loan_type + ')';
            // }
            if (this.data.subject?.loan_number && this.data.subject?.principal_amount) {
                description += ' - ' + this.data.subject.loan_number + (this.data.subject?.reason ? ' (' + this.data.subject.reason + ')' : '') + ', Amount: GHS' + this.data.subject.principal_amount + (this.data.subject?.loan_type ? ', ' + this.data.subject.loan_type : '');
            }
            if (this.data?.causer && this.data?.causer.trans_amount) {
                description += ' - Amount: GHS ' + this.data.causer.trans_amount;
            }

            return description;
        },
        getUser() {
            if (this.data.causer && this.data.causer.first_name && this.data.causer.surname) {
                return this.data.causer
                    ?.first_name + (this.data.causer.middle_name ? " " + this.data.causer.middle_name : "") + " " + this.data.causer?.surname + " - " + this.data.causer?.id + " (" +
                    this.data.causer?.username + ")";
            }
            return "";
        },
    },
    methods: {
        async getJournalView() {
            this.isLoading = true;
            // console.log("Start")
            // this.items = [];
            // this.details = {};
            //  this.search = "processing";
            //  this.isSearching = true;
            // console.log(this.data);
            await ApiService.get(`/journals/view/${this.data.id}`).then((response) => {
                const account = [];
                this.form = response.data.data;
                this.form.vouch_journal_coaaccounts.map((index) => {
                    account.push({
                        'id': index.id,
                        'amount_approved': index?.amount_approved,
                        'amount_requested': index?.amount_requested,
                        'dr_amount': index?.dr_amount,
                        'cr_amount': index?.cr_amount,
                        'dr_amount_approved': index?.dr_amount_approved,
                        'cr_amount_approved': index?.cr_amount_approved,
                        'coa_sub_head': index.coa_sub_head?.name,
                    })
                });
                console.log(account)
                this.items = account
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false
                console.log(error);
            })
        },
        ModalOpened() {
            // this.getJournalView();
        },
    }
}
</script>